import { getClientEnv } from "@shared/env";
import axios, {
	type AxiosError,
	type InternalAxiosRequestConfig,
} from "axios";
import { useAuthStore } from "@/modules/auth/store/auth.store";

const env = getClientEnv();

export const apiClient = axios.create({
	baseURL: `${env.VITE_API_URL}/api/v1`,
	headers: {
		"Content-Type": "application/json",
	},
});

// Request interceptor - attach access token
apiClient.interceptors.request.use(
	(config: InternalAxiosRequestConfig) => {
		const accessToken = useAuthStore.getState().accessToken;
		if (accessToken) {
			config.headers.Authorization = `Bearer ${accessToken}`;
		}
		return config;
	},
	(error) => Promise.reject(error),
);

// Response interceptor - handle 401
apiClient.interceptors.response.use(
	(response) => response,
	async (error: AxiosError) => {
		if (error.response?.status === 401) {
			useAuthStore.getState().logout();
			window.location.href = "/login";
		}
		return Promise.reject(error);
	},
);

export default apiClient;
